export default "__VITE_ASSET__64b7da30__"